export default function getFavoriteListDisplayName(list) {
  if (!list) {
    return '';
  }

  return list.is_default ? `${list.name} (Default List)` : list.name;
}
